const { isCountryInContinent, EUROPE, ISRAEL_ISO2 } = require("../countries/countries-service");
const { USE_OLD_STORAGE_SETTINGS } = require("../../constants/cookies");

const { getAbTestVariantNew } = require("../new-ab-tests/new-ab-tests-service");
const {
  DEV_PRODUCT_ID,
  PROJECTS_PRODUCT_ID,
  CRM_PRODUCT_ID,
  MARKETER_PRODUCT_ID
} = require("../../constants/products");

const { doesCountryRequireStrictCookiePolicy } = require("../../server/services/aws-service/browser-service");
const { isRunningInClient } = require("../dom-utils-service");
const { getUrlParamValue } = require("../../utils/url");

const {
  SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST,
  DRIFT_PRICING_CHATBOT_CONTACT_SALES_AB_TEST,
  EXIT_POP_UP_SURVEY_AB_TEST,
  LEARN_MORE_AND_SIGNUP_BUTTON,
  LEARN_MORE_TO_PRODUCT_BUTTON,
  REVIVE_EXIT_POPUP_AB_TEST,
  PERFORMANCE_STATIC_PAGE_AB_TEST,
  BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES,
  TEMPLATES_IN_HEADER_AB_TEST,
  DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST,
  PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST,
  MOBILE_STICKY_SIGNUP_AB_TEST,
  ENRICHMENT_HOMEPAGE_SALES_CTA_AB_TEST,
  ENRICHEMNT_DRIFT_CRM_LP_AB_TEST,
  MAIN_SIGNUP_AB_TEST,
  LP_SIGNUP_POPUP_WITHOUT_ASSET_AB_TEST,
  HEADER_WITHOUT_MENU_AND_WITH_CONTACT_SALES_TEST,
  BRAND_CAMPAIGN_HEADER_TEST,
  CRM_PRODUCT_FULL_FLOW_TEST,
  DEV_PRODUCT_FULL_FLOW_TEST,
  PROJECTS_PRODUCT_FULL_FLOW_TEST,
  MARKETING_PRODUCT_FULL_FLOW_TEST,
  WELCOME_BACK_PAGE_TEST,
  KEEP_REGION_TEST,
  CONTACT_SALES_TYPEFORM_TEST,
  SIGNUP_WITH_PRODUCT_PAGE_WITH_PRODUCT_RECOMMENDATION_TEST,
  HEADER_WITHOUT_PROJECTS_TEST,
  SIGNUP_WITH_PRODUCT_PAGE_WITHOUT_PRODUCT_RECOMMENDATION_TEST
} = require("../../constants/new-ab-tests");

const shouldGetSkipSignUpStepInPricingAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return getAbTestVariantNew(abTests, SKIP_SIGN_UP_STEP_IN_PRICING_PAGE_AB_TEST, sendBigBrainEvent) === "new_with_skip";
};

const shouldGetPricingChatbotContactSalesAbTest = (abTests = [], sendBigBrainEvent) => {
  return (
    getAbTestVariantNew(abTests, DRIFT_PRICING_CHATBOT_CONTACT_SALES_AB_TEST, sendBigBrainEvent) === "new_with_chat"
  );
};

const shouldSeeExitPopupSurveyAbTest = (abTests = [], sendBigBrainEvent) => {
  return getAbTestVariantNew(abTests, EXIT_POP_UP_SURVEY_AB_TEST, sendBigBrainEvent) === "new_with_survey";
};

const shouldSeeLearnMoreAndSignupButton = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, LEARN_MORE_AND_SIGNUP_BUTTON.test_name, sendBigBrainEvent) ===
    LEARN_MORE_AND_SIGNUP_BUTTON.new_variation_name
  );
};

const shouldSeeLearnMoreToProductButton = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, LEARN_MORE_TO_PRODUCT_BUTTON.test_name, sendBigBrainEvent) ===
    LEARN_MORE_TO_PRODUCT_BUTTON.new_variation_name
  );
};

const shouldSeeReviveExitPopupAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, REVIVE_EXIT_POPUP_AB_TEST.test_name, sendBigBrainEvent) ===
    REVIVE_EXIT_POPUP_AB_TEST.new_variation_name
  );
};

const shouldSeeStaticPagePerformanceAbTest = (
  abTests = [],
  cloudfrontViewerCountry = null,
  sendBigBrainEvent = false
) => {
  if (doesCountryRequireStrictCookiePolicy(cloudfrontViewerCountry)) return false;
  return (
    getAbTestVariantNew(abTests, PERFORMANCE_STATIC_PAGE_AB_TEST.test_name, sendBigBrainEvent) ===
    PERFORMANCE_STATIC_PAGE_AB_TEST.new_variation_name
  );
};

const shouldShowBiggerStorageInPricingFeatures = (abTests = [], cookies = {}, sendBigBrainEvent = false) => {
  if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
    return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
  }
  return (
    getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) ===
    BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name
  );
};

const shouldSeeTemplatesInHeader = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, TEMPLATES_IN_HEADER_AB_TEST.test_name, sendBigBrainEvent) ===
    TEMPLATES_IN_HEADER_AB_TEST.new_variation_name
  );
};

const shouldSeeDesktopWithEnterpriseMenuAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.test_name, sendBigBrainEvent) ===
    DESKTOP_WITH_ENTERPRISE_IN_SUBMENU_TEST.new_variation_name
  );
};

const shouldGetEnterpriseContactUsPageAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.test_name, sendBigBrainEvent) ===
    PRICING_ENTERPRISE_CONTACT_SALES_AB_TEST.new_variation_name
  );
};

const shouldGetMobileStickySignupAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, MOBILE_STICKY_SIGNUP_AB_TEST.test_name, sendBigBrainEvent) ===
    MOBILE_STICKY_SIGNUP_AB_TEST.new_variation_name
  );
};

const shouldSeeEnrichmentHomepageSalesCtaAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, ENRICHMENT_HOMEPAGE_SALES_CTA_AB_TEST.test_name, sendBigBrainEvent) ===
    ENRICHMENT_HOMEPAGE_SALES_CTA_AB_TEST.new_variation_name
  );
};

const shouldRenderDriftScriptCrmLpAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, ENRICHEMNT_DRIFT_CRM_LP_AB_TEST.test_name, sendBigBrainEvent) ===
    ENRICHEMNT_DRIFT_CRM_LP_AB_TEST.new_variation_name
  );
};

const shouldRenderSignupPopupAbTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, MAIN_SIGNUP_AB_TEST.test_name, sendBigBrainEvent) ===
    MAIN_SIGNUP_AB_TEST.new_variation_name
  );
};

const shouldRenderSignupPopupWithoutAssetAbTest = (abTests = [], sendBigBrainEvent = false) => {
  try {
    if (isRunningInClient() && localStorage?.getItem("signUpNoAsset") === "true") return true;
  } catch (e) {
    // nothing to dojust prevent any chance of crash.
  }
  return (
    getAbTestVariantNew(abTests, LP_SIGNUP_POPUP_WITHOUT_ASSET_AB_TEST.test_name, sendBigBrainEvent) ===
    LP_SIGNUP_POPUP_WITHOUT_ASSET_AB_TEST.new_variation_name
  );
};

const shouldRenderHeaderWithoutMenuAndContactSalesTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, HEADER_WITHOUT_MENU_AND_WITH_CONTACT_SALES_TEST.test_name, sendBigBrainEvent) ===
    HEADER_WITHOUT_MENU_AND_WITH_CONTACT_SALES_TEST.new_variation_name
  );
};

const shouldRenderBrandCampaignHeaderTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, BRAND_CAMPAIGN_HEADER_TEST.test_name, sendBigBrainEvent) ===
    BRAND_CAMPAIGN_HEADER_TEST.new_variation_name
  );
};

const shouldGetProductFullFlowSignupTest = (abTests = [], productId, sendBigBrainEvent = false) => {
  // Marketing and Work management are excluded from the test

  const AB_TEST_LINKS = {
    [DEV_PRODUCT_ID]: DEV_PRODUCT_FULL_FLOW_TEST,
    [CRM_PRODUCT_ID]: CRM_PRODUCT_FULL_FLOW_TEST,
    [PROJECTS_PRODUCT_ID]: PROJECTS_PRODUCT_FULL_FLOW_TEST,
    [MARKETER_PRODUCT_ID]: MARKETING_PRODUCT_FULL_FLOW_TEST // we won't start the marketer test for now
  };
  const abTestForProduct = AB_TEST_LINKS[productId];

  if (!abTestForProduct) return false;

  try {
    if (isRunningInClient() && localStorage?.getItem("products") === "true") return true;
  } catch (e) {
    // nothing to do just prevent any chance of crash.
  }

  return (
    getAbTestVariantNew(abTests, abTestForProduct.test_name, sendBigBrainEvent) === abTestForProduct.new_variation_name
  );
};

const shouldGetWelcomeBackPageTest = (abTests = [], pagePath, sendBigBrainEvent = false, extraBigBrainParams = {}) => {
  if (getUrlParamValue(pagePath, "test") === "welcome-back-debugging") return true;

  return (
    getAbTestVariantNew(abTests, WELCOME_BACK_PAGE_TEST.test_name, sendBigBrainEvent, false, extraBigBrainParams) ===
    WELCOME_BACK_PAGE_TEST.new_variation_name
  );
};

const shouldGetKeepRegionTest = (abTests = [], cloudfrontViewerCountry = null, sendBigBrainEvent = false) => {
  try {
    if (isRunningInClient() && localStorage?.getItem("is_in_keep_region_test") === "true") {
      return true;
    }
    if (!(isCountryInContinent(cloudfrontViewerCountry, EUROPE) || cloudfrontViewerCountry === ISRAEL_ISO2)) {
      // only people from European countries - and Israel, as honorary Europeans - should enter the test
      return false;
    }
  } catch (error) {
    // nothing to do - just done to protect from crashes
  }
  return (
    getAbTestVariantNew(abTests, KEEP_REGION_TEST.test_name, sendBigBrainEvent) === KEEP_REGION_TEST.new_variation_name
  );
};

const shouldGetContactSalesTypeformTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, CONTACT_SALES_TYPEFORM_TEST.test_name, sendBigBrainEvent) ===
    CONTACT_SALES_TYPEFORM_TEST.new_variation_name
  );
};

const shouldSendToSignupWithProductPageWithoutProductRecommendationTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, SIGNUP_WITH_PRODUCT_PAGE_WITHOUT_PRODUCT_RECOMMENDATION_TEST.test_name, sendBigBrainEvent) ===
    SIGNUP_WITH_PRODUCT_PAGE_WITHOUT_PRODUCT_RECOMMENDATION_TEST.new_variation_name
  );
};

const shouldSendToSignupWithProductPageWithProductRecommendationTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, SIGNUP_WITH_PRODUCT_PAGE_WITH_PRODUCT_RECOMMENDATION_TEST.test_name, sendBigBrainEvent) ===
    SIGNUP_WITH_PRODUCT_PAGE_WITH_PRODUCT_RECOMMENDATION_TEST.new_variation_name
  );
};

const shouldHaveHeaderWithoutProjectsTest = (abTests = [], sendBigBrainEvent = false) => {
  return (
    getAbTestVariantNew(abTests, HEADER_WITHOUT_PROJECTS_TEST.test_name, sendBigBrainEvent) ===
    HEADER_WITHOUT_PROJECTS_TEST.new_variation_name
  );
};

module.exports = {
  shouldGetSkipSignUpStepInPricingAbTest,
  shouldGetPricingChatbotContactSalesAbTest,
  shouldSeeExitPopupSurveyAbTest,
  shouldSeeLearnMoreAndSignupButton,
  shouldSeeLearnMoreToProductButton,
  shouldSeeReviveExitPopupAbTest,
  shouldSeeStaticPagePerformanceAbTest,
  shouldShowBiggerStorageInPricingFeatures,
  shouldSeeTemplatesInHeader,
  shouldSeeDesktopWithEnterpriseMenuAbTest,
  shouldGetEnterpriseContactUsPageAbTest,
  shouldGetMobileStickySignupAbTest,
  shouldSeeEnrichmentHomepageSalesCtaAbTest,
  shouldRenderDriftScriptCrmLpAbTest,
  shouldRenderSignupPopupAbTest,
  shouldRenderSignupPopupWithoutAssetAbTest,
  shouldRenderHeaderWithoutMenuAndContactSalesTest,
  shouldRenderBrandCampaignHeaderTest,
  shouldGetProductFullFlowSignupTest,
  shouldGetWelcomeBackPageTest,
  shouldGetKeepRegionTest,
  shouldGetContactSalesTypeformTest,
  shouldSendToSignupWithProductPageWithoutProductRecommendationTest,
  shouldSendToSignupWithProductPageWithProductRecommendationTest,
  shouldHaveHeaderWithoutProjectsTest
};
